import script from "./LocationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationPage.vue?vue&type=script&setup=true&lang=js"

import "./LocationPage.vue?vue&type=style&index=0&id=20117c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20117c84"]])

export default __exports__